import { LogIn } from 'lucide-react'
import { useState } from 'react'
import logo from '@/assets/logo.svg'
import { useOnline } from '@/shared/hooks/useOnline'
import { useAuth } from './AuthContext'

// Connexion opérateur et état de la tablette (maquettes). La copie de secours des routes et l'accès secours
// arriveront avec le mode secours (lot O6) : ils ne sont pas proposés avant d'exister.

export function LoginPage({ demo = false }: { demo?: boolean }) {
  const auth = useAuth()
  const online = useOnline()
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [pending, setPending] = useState(false)

  return (
    <main className="op-screen op-screen--center">
      <div className="op-login-layout">
        <form
          className="op-card op-login"
          onSubmit={(event) => {
            event.preventDefault()
            setPending(true)
            auth
              .signIn(identifier, password)
              .catch(() => undefined)
              .finally(() => {
                setPending(false)
              })
          }}
        >
          <img src={logo} alt="Groupe RÉCA" className="op-login__logo" />
          <h1>Connexion opérateur</h1>
          <label className="op-field">
            <span>Identifiant</span>
            <input
              autoComplete="username"
              inputMode="email"
              autoCapitalize="none"
              placeholder="p.nom@groupereca.com"
              value={identifier}
              onChange={(event) => {
                setIdentifier(event.target.value)
              }}
              required
            />
          </label>
          <label className="op-field">
            <span>Mot de passe</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value)
              }}
              required
            />
          </label>
          {auth.error ? (
            <p className="op-error" role="alert">
              {auth.error}
            </p>
          ) : null}
          {!online ? (
            <p className="op-error" role="status">
              Le réseau est indisponible. La connexion est impossible pour l’instant.
            </p>
          ) : null}
          <button
            type="submit"
            className="field-button field-button--primary field-button--tall"
            disabled={pending || !online}
          >
            <LogIn aria-hidden="true" /> {pending ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <section className="op-card op-tablet" aria-labelledby="op-tablet-title">
          <h2 id="op-tablet-title" className="field-eyebrow">
            État de la tablette
          </h2>
          <dl>
            <div>
              <dt>Réseau</dt>
              <dd className={online ? 'is-ok' : 'is-error'}>{online ? '● Disponible' : 'Hors ligne'}</dd>
            </div>
            <div>
              <dt>Copie de secours des routes</dt>
              <dd>Pas encore disponible : le mode secours arrive dans une prochaine version.</dd>
            </div>
          </dl>
          {demo ? <p className="op-muted">Démo · données fictives</p> : null}
        </section>
      </div>
    </main>
  )
}
